import { setLoader, setStatus } from "./User";
import ActionTypes from "./ActionTypes";
import ErrorMsgs from "../../constants/Errors.json";
import BoundaryApi from "../../services/api/Boundary";
import SuccessMessages from "../../constants/SucessMessages.json";

const handleError = (err) => {
  console.log("[handleError] Error in Boundaries actions", err);
};

export const setActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_FILTERS_BOUNDARIES,
    payload,
  };
};

export const setBoundaries = (payload) => {
  return {
    type: ActionTypes.SET_GEO_BOUNDARIES,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_BOUNDARIES_STATE,
    payload,
  };
};

export const loadBoundaryLists = (boundariesFilter) => async (dispatch) => {
  try {
    let finalPayload = {};

    //set zone params
    finalPayload.zone = {
      zone_supported: boundariesFilter.zone_supported,
      zone_unsupported: boundariesFilter.zone_unsupported,
    };

    if (
      !boundariesFilter.zone_supported &&
      !boundariesFilter.zone_unsupported &&
      boundariesFilter.show_type !== "locality"
    ) {
      boundariesFilter.zone_supported = true;
      finalPayload.zone.zone_supported = true;
    }

    //set locality params
    if (boundariesFilter.isLocalitySupported || boundariesFilter.isTest) {
      finalPayload["locality"] = {};
    }

    if (boundariesFilter.isLocalitySupported) {
      finalPayload["locality"]["is_locality_supported"] = true;
    }
    if (boundariesFilter.isTest) {
      finalPayload["locality"]["is_test"] = true;
    }

    finalPayload["city_ids"] = boundariesFilter.cityIds;
    finalPayload["show_type"] = boundariesFilter.show_type;

    dispatch(setLoader(true));
    let response = await BoundaryApi.getGeoBoundaries(finalPayload);
    if (response) {
      dispatch(setBoundaries(response));
      dispatch(setActiveFilters(boundariesFilter));
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.GENERAL_SUCCESS_MESSAGE,
        })
      );
    }
    dispatch(setLoader(false));
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
